import React, { useEffect } from 'react';
import useData from '../hooks/useData';
import useApp from '../hooks/useApp';

const ExhibitorListPrint = () => {
	const { exhibitorInfo } = useData();
	const { isCHT, setLanguage } = useApp();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const lang = urlParams.get('lang');
		setLanguage(lang);
	}, [setLanguage]);

	useEffect(() => {
		setTimeout(() => {
			window.print();
		}, 1000);
	}, []);

	return (
		<div id='ExhibitorListPrint'>
			<div className='panel-heading'>{isCHT ? '廠商名單' : 'Exhibitor List'}</div>
			<div className='panel-body'>

				<div className='exhibitors'>
					{exhibitorInfo.map((exhibitor, index) => {
						const exhibitorName = isCHT ? exhibitor['廠商名稱-中文'] : exhibitor['廠商名稱-英文'];
						const booth = exhibitor['攤位號碼'];

						return (
							<div className='exhibitor' key={`exhibitorLinkTableRow${index}`}>
								<div className='name'>{exhibitorName}</div>
								<div className='booth-number'>{booth}</div>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default ExhibitorListPrint;